<span class="cronometro">{{ hora }}:{{ minutos }}:{{ segundos }}</span>
